import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { DQOIReferenceData } from '@app/cp/shared/models/DQOIReferenceData';

export interface DQOIReferenceDataState extends EntityState<DQOIReferenceData> { }

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'DQOIReferenceData', idKey: 'id'  })
export class DQOIReferenceDataStore extends EntityStore<DQOIReferenceDataState, DQOIReferenceData> {
  constructor() {
    super();
    }

}
